import { render, staticRenderFns } from "./NanoBanana.vue?vue&type=template&id=c2a93208&scoped=true"
import script from "./NanoBanana.vue?vue&type=script&lang=js"
export * from "./NanoBanana.vue?vue&type=script&lang=js"
import style0 from "./NanoBanana.vue?vue&type=style&index=0&id=c2a93208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a93208",
  null
  
)

export default component.exports